import React from 'react'

import brandConfig from 'branding'
import { shouldDoRedirect } from 'containers/DealerRedirector/DealerRedirector'
import useUser from 'hooks/useUser'

import { FooterContainer, FooterText, FooterWrapper } from './Footer.styled'

function Footer(): JSX.Element | null {
    const { user, isLoggedIn } = useUser()

    if (isLoggedIn === undefined) {
        return null
    }

    if (brandConfig.hideFooterAtLogin && !isLoggedIn) {
        return null
    }

    if (isLoggedIn) {
        const redirectExpected = shouldDoRedirect(user?.dealerPortalUrl)

        if (redirectExpected === undefined || redirectExpected === true) {
            return null
        }
    }

    if (!brandConfig.footerContent) {
        return null
    }

    return (
        <FooterWrapper>
            <FooterContainer>
                <FooterText>{brandConfig.footerContent}</FooterText>
            </FooterContainer>
        </FooterWrapper>
    )
}

export default Footer
